import React, { Component, lazy, Suspense } from 'react';
import './App.css';
// import Tree from './Tree';
import track from 'tracker';
import Uebersicht from './Übersicht';
import Montageanleitung from './Montageanleitung';
import Header from './Header';
import FirstVisitPopup from './FirstVisitPopup';
import Value from './Context';
import Texts from './texts.json';

const Tree = lazy(() => import('./Tree'));

class App extends Component {
  constructor() {
    super();

    this.changeMenuArray = (arr) => {
      this.setState({ menuArray: arr });
    };

    this.changeVersion = (version) => {
      this.setState({ version });
    };

    this.changePremium = (premium) => {
      this.setState({ premium });
    };

    this.changeQuadro = (quadro) => {
      this.setState({ quadro });
    };

    this.searchMenuArray = (val) => {
      if (val === '') {
        return [];
      }
      const result = [];
      this.state.menuArray.map((item) => {
        if (item.name.toLowerCase().includes(val.toLowerCase())) {
          result.push(item);
        }
      });
      return result;
    };

    this.searchMenuArrayforParentNamebyKey = (key) => {
      let res;
      this.state.menuArray.map((item) => {
        if (item.key === key) {
          res = item;
        }
      });
      return res;
    };

    this.changeactiveMenu = (menu) => {
      this.setState({ activeMenu: menu });
    };

    this.getText = () => {
      if (this.state.locale === 'de') {
        return Texts.de;
      }
      return Texts.en;
    };

    this.state = {
      version: '4.1',
      premium: false,
      quadro: false,
      locale: this.setLocale(),
      menuArray: [],
      activeMenu: 'N',
      changeVersion: this.changeVersion,
      changePremium: this.changePremium,
      changeQuadro: this.changeQuadro,
      changeMenuArray: this.changeMenuArray,
      searchMenuArray: this.searchMenuArray,
      searchMenuArrayforParentNamebyKey: this.searchMenuArrayforParentNamebyKey,
      changeactiveMenu: this.changeactiveMenu,
      getText: this.getText,
    };
  }

  // eslint-disable-next-line class-methods-use-this
  componentDidMount() {
    track('HS');
  }

  // eslint-disable-next-line class-methods-use-this
  setLocale() {
    return document.baseURI.substring(document.baseURI.length - 2, document.baseURI.length);
  }

  handleActiveMenu() {
    switch (this.state.activeMenu) {
      case 'N':
        return (
          <Suspense fallback={<div>Loading</div>}>
            <Tree />
          </Suspense>
        );
      case 'Ü':
        return <Uebersicht />;
      case 'M':
        return <Montageanleitung />;
      default:
        return (
          <Suspense fallback={<div>Loading</div>}>
            <Tree />
          </Suspense>
        );
    }
  }

  render() {
    return (
      <Value.Provider value={this.state}>
        <>
          <div className='App'>
            <Header />
            <div className='Baum'>{this.handleActiveMenu()}</div>
            {!localStorage.getItem('HS_Remember_me') ? <FirstVisitPopup /> : ''}
          </div>
        </>
      </Value.Provider>
    );
  }
}

export default App;
